import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Input,
  ViewChild,
} from '@angular/core';
import { CourseService } from '@scaffold/services/course.service';
import { DataModelService } from '@services/data-model.service';
import { searchObject } from '@app/framework/search-bar/search-bar.component';
import { TranslationService } from '@services/translation.service';
import { ItemsService } from '@scaffold/services/items.service';

@Component({
    selector: 'app-data-search',
    templateUrl: './data-search.component.html',
    styleUrls: ['./data-search.component.scss'],
    standalone: false
})
export class DataSearchComponent implements OnInit {
  @Output() selectItem = new EventEmitter<any>();
  @Input() data;
  results;
  selected;
  value;
  listSearchOptions = [];
  listSearchTerm;
  listSearchValue;
  listPageNumber = 1;
  listItemsPerPage = 25;
  listTotalNumberOfItems = 0;
  data_check = {};
  _perPage = 10;
  searchData: searchObject;
  attemptedHeaders: boolean;
  headers: any[] = [];
  set perPage(count) {
    console.log(count);
    this._perPage = count;
  }
  get perPage() {
    return this._perPage;
  }
  itemCount = 0;
  private _active: number = 1;
  set active(page: number) {
    console.log(page);
    this._active = page;
    this.getListItems();
  }
  get active(): number {
    return this._active;
  }
  constructor(
    private translationService: TranslationService,
    private courseService: CourseService,
    private dataModelService: DataModelService,
    private itemsService: ItemsService
  ) {}

  /*
   *selectedItem: selectedItem,
        currentValue: this.item.value,
        type: this.item.type,
        search_type: this.item.toload_type,
        search_mode: this.item.search_mode || 'list',
        context: context,
        route: this.route,
        allow_multiple: allow_multiple,
        window_title: this.item.search_title && this.item.search_title.length > 0 ? this.item.search_title  : ('Select Items to Link' + (selectedItem.title ? (" to " + selectedItem.title) : "")),
        horizontal_list: this.item.horizontal_list,
        hide_search: this.item.hide_search,
        filter: this.item.filter_search,
        params: { param: this.item.param, req_value: this.item.req_value },
        prevent_create: this.item.prevent_create   *
   * */

  ngOnInit() {
    console.log(this.data);
    this.getListItems();
  }

  addSearchItems(keys) {
    if (keys && keys.length > 0) {
      keys.forEach(key => {
        const searchKey = {
          displayName:
            key.json_data && key.json_data.friendlyName
              ? key.json_data.friendlyName
              : key.name,
          value: key.name,
        };
        this.listSearchOptions.push(searchKey);
      });
    }
  }

  isLinked(id, item?) {
    let found = false;
    if (
      this.data &&
      this.data.selectedItem &&
      this.data.selectedItem.links &&
      this.data.allow_multiple
    ) {
      this.data.selectedItem.links.forEach(link => {
        if (link.linked_id == id) {
          if (item) {
            if (link.id) {
              item.link_id = link.id;
              console.log('LINK SET');
            } else {
              //get id for newly created links that may not have one
              item.links.forEach(l => {
                if (l.linked_id == this.data.selectedItem.id) {
                  item.link_id = l.id;
                  console.log('LINK SET');
                }
              });
            }
            item.link_parent = this.data.selectedItem.id;
            item.link_parent_type = this.data.selectedItem.type;
          }
          found = true;
        }
      });
    } else {
      if (id == this.data.currentValue) found = true;
    }
    return found;
  }

  /**
   * Generates url to load item for this list
   * */
  generateListUrl(): string {
    let base;
    base = this.data.search_type;
    let url = '';
    if (this.data.context && this.data.context.type && this.data.context.id) {
      url = this.data.context.type + '/' + this.data.context.id + '/' + base;
    } else {
      url = '' + base;
    }
    url += `?mode=${this.data.search_mode || 'list'}`;
    return url;
  }

  /**
   *Get a filtered list of item in this list based on any search settting
   * */
  getListItems() {
    let query = '';
    console.log('per page', this._perPage);
    if (this.data.paginate_results) {
      console.log('paginate');
      query += '&pageNumber=' + (this.active - 1);

      if (this._perPage) {
        query += '&perPage=' + this._perPage;
      }
    }
    /*
             filter: this.item.filter_search,
        params: { param: this.item.param, req_value: this.item.req_value },*/
    if (this.data.filter) {
      query +=
        '&searchParam=' +
        this.data.params.param +
        '&searchTerm=' +
        encodeURIComponent(this.data.params.req_value);
    } else {
      if (this.searchData && this.searchData.key != null) {
        query +=
          '&searchParam=' +
          this.searchData.key +
          '&searchTerm=' +
          encodeURIComponent(this.searchData.term);
      }
    }
    if (this.data.context && this.data.context.get_all) {
      query += '&allchildren=true';
    }
    let url = this.generateListUrl();
    this.courseService.get(url + query).subscribe(co => {
      this.processItems(co);
    });
  }
  perPageChange(e) {
    this.perPage = e;
    this.active = 1;
  }
  search(data: searchObject) {
    this.searchData = data;
    this._active = 1;
    this.getListItems();
  }
  processItems(co, initial?) {
    if (!this.results) this.results = [];
    if (co && co.totalItems) {
      this.listTotalNumberOfItems = co.totalItems;
    }
    if (co && co.push) {
      co = { listItems: co };
      this.listTotalNumberOfItems = co.length;
    }
    if (co && co.id) {
      co = { listItems: [co] };
      this.listTotalNumberOfItems = 1;
    }
    if (!this.listTotalNumberOfItems) {
      this.listTotalNumberOfItems = co?.listItems?.length || 0;
    }
    console.log(
      JSON.stringify(
        this.results.map(i => {
          return i.title;
        })
      )
    );
    /*co.listItems.forEach((v, i) => {
      let pos = this.findInView(v);
      if (pos > -1){
        this.view[pos] = v;
      } else {
        this.view.push(v);
      }
    });*/
    this.results = co.listItems;

    if (this.data.headers && this.data.headers.length > 0) {
      this.headers = [...this.data.headers];
    } else if (this.data.use_dynamic_headers && !this.attemptedHeaders) {
      this.setupHeaders();
    }

    if (
      this.data.allow_multiple &&
      !this.data.horizontal_list &&
      this.results &&
      this.results.length > 0 &&
      !this.data.headers &&
      this.data.use_dynamic_headers
    ) {
      const hasCheckboxColumn =
        this.headers &&
        this.headers.length > 0 &&
        this.headers[0].header_text === '';

      if (!this.headers || this.headers.length === 0) {
        this.headers = [
          {
            header_text: '',
            header_width: 'flex-column-1',
            text_transform_header: 'uppercase',
          },
        ];
      } else if (!hasCheckboxColumn) {
        this.headers.unshift({
          header_text: '',
          header_width: 'flex-column-1',
          text_transform_header: 'uppercase',
        });
      }
    }

    this.results.forEach(i => {
      const linked = this.isLinked(i.id, i) ? true : false;
      if (!this.data_check.hasOwnProperty(i.id)) {
        this.data_check[i.id] = {
          linked: linked,
          item: i,
          link_exists: linked,
        };
      }
    });
    this.itemCount = co.totalItems || co.listItems.length;
  }

  setSelected(item, index) {
    console.log(item);
    if (this.data.allow_multiple) {
      this.data_check[item.id].linked = !this.data_check[item.id].linked;
      this.selectItem.emit(this.toArray(this.data_check));
    } else {
      this.selected = item;
      this.selectItem.emit(item.id);
    }
  }

  checkbox(e) {
    e.stopPropagation();
  }

  toArray(obj) {
    return Object.keys(obj).map(i => obj[i]);
  }

  getCountLabel() {
    if (!this.listTotalNumberOfItems) return '';
    const of = this.translationService.getTranslatedContent('of', 'of');
    const items = this.translationService.getTranslatedContent(
      'items',
      'Items'
    );
    let start = this.active * this.perPage - this.perPage + 1;
    let end = Math.min(this.active * this.perPage, this.listTotalNumberOfItems);
    return `${start} - ${end} ${of} ${this.listTotalNumberOfItems} ${items}`;
  }

  checkCondition(value: any, item: any): boolean {
    if (
      item.condition &&
      ((value != undefined && item.req_value) ||
        item.condition == 'notdefined' ||
        (value !== false && item.condition == 'defined') ||
        (value && item.condition == 'true') ||
        item.condition == 'false')
    ) {
      switch (item.condition) {
        case 'equal':
          if (item.req_value.indexOf(',') >= 0) {
            let vals = item.req_value.split(/\s*,\s*/g);
            return (
              vals.indexOf(value.toString()) >= 0 || vals.indexOf(value) >= 0
            );
          } else {
            return value.toString() == item.req_value;
          }

        case 'less':
          if (!isNaN(value) && !isNaN(item.req_value))
            return Number(value) < Number(item.req_value);
          else return value < item.req_value;

        case 'notdefined':
          return value == null && item.value == null;

        case 'defined':
          return value != null || item.value != null;

        case 'length':
          const strValue = '' + value;
          if (item.length_comparison === 'less') {
            return strValue.length < Number(item.req_value);
          }
          return strValue.length >= Number(item.req_value);

        case 'regex':
          let flags;
          if (!item.req_value || item.req_value.length === 0) {
            return false;
          }
          let pattern = item.req_value;
          if (pattern.indexOf('|') >= 0) {
            const split = pattern.split('|');
            flags = split[1];
            pattern = split[0];
          }
          let test = new RegExp(pattern, flags);
          return test.test(value);

        case 'greater':
          if (!isNaN(value) && !isNaN(item.req_value))
            return Number(value) > Number(item.req_value);
          else return value > item.req_value;

        case 'notequal':
          if (item.req_value.indexOf(',') >= 0) {
            var vals = item.req_value.split(/\s*,\s*/g);
            return (
              vals.indexOf(value.toString()) < 0 && vals.indexOf(value) < 0
            );
          } else {
            return value.toString() != item.req_value;
          }

        case 'true':
          if (item.value === true || item.value === 'true') {
            return true;
          }
          break;
        case 'false':
          if (
            item.value === false ||
            item.value === 'false' ||
            item.value === undefined
          ) {
            return true;
          }
          break;
        default:
          return false;
      }
      return false;
    }
    return false;
  }

  getFieldNameFromItem(item: any): string | null {
    if (
      item.type === 'template' &&
      item.content &&
      Array.isArray(item.content)
    ) {
      const nameItem = item.content.find(
        c => c.name && c.input_type === 'data'
      );
      return nameItem ? nameItem.name : null;
    }
    if (item.type === 'link' && item.name) {
      return item.name;
    }
    return item.name;
  }

  setupHeaders() {
    if (this.results && this.results.length > 0 && !this.attemptedHeaders) {
      this.attemptedHeaders = true;
      const firstResult = this.results[0];
      if (firstResult && firstResult.data && firstResult.data.content) {
        const headers = [];
        const seenNames = new Set();

        const extractFieldNames = (
          content,
          parentWidth = 'flex-column-1',
          resultData = firstResult.data
        ) => {
          content.forEach(item => {
            if (item.type === 'conditional') {
              let value = item.value;
              if (item.name && resultData) {
                const dataValue = this.itemsService.get(resultData, item.name);
                if (dataValue !== undefined) {
                  value = dataValue;
                }
              }
              if (!this.checkCondition(value, item)) {
                return;
              }
            }

            if (
              item.type === 'flex' &&
              item.content &&
              Array.isArray(item.content)
            ) {
              item.content.forEach(flexItem => {
                if (flexItem.content && Array.isArray(flexItem.content)) {
                  flexItem.content.forEach(subItem => {
                    if (subItem.type === 'conditional') {
                      let value = subItem.value;
                      if (subItem.name && resultData) {
                        const dataValue = this.itemsService.get(
                          resultData,
                          subItem.name
                        );
                        if (dataValue !== undefined) {
                          value = dataValue;
                        }
                      }
                      if (!this.checkCondition(value, subItem)) {
                        return;
                      }
                      if (subItem.content && Array.isArray(subItem.content)) {
                        subItem.content.forEach(condContentItem => {
                          const fieldName =
                            this.getFieldNameFromItem(condContentItem);
                          if (fieldName && !seenNames.has(fieldName)) {
                            seenNames.add(fieldName);
                            let displayName =
                              this.translationService.getTranslatedContent(
                                fieldName,
                                null
                              );
                            if (
                              !displayName ||
                              displayName.includes('_') ||
                              displayName.includes('-')
                            ) {
                              displayName = (displayName || fieldName)
                                .replace(/_/g, ' ')
                                .replace(/-/g, ' ')
                                .replace(/\b\w/g, l => l.toUpperCase());
                            }
                            headers.push({
                              header_text: displayName,
                              header_width: flexItem.flex_width || parentWidth,
                              text_transform_header: 'uppercase',
                            });
                          }
                        });
                      }
                    } else {
                      const fieldName = this.getFieldNameFromItem(subItem);
                      if (fieldName && !seenNames.has(fieldName)) {
                        seenNames.add(fieldName);
                        let displayName =
                          this.translationService.getTranslatedContent(
                            fieldName,
                            null
                          );
                        if (
                          !displayName ||
                          displayName.includes('_') ||
                          displayName.includes('-')
                        ) {
                          displayName = (displayName || fieldName)
                            .replace(/_/g, ' ')
                            .replace(/-/g, ' ')
                            .replace(/\b\w/g, l => l.toUpperCase());
                        }
                        headers.push({
                          header_text: displayName,
                          header_width: flexItem.flex_width || parentWidth,
                          text_transform_header: 'uppercase',
                        });
                      }
                    }
                  });
                }
              });
            } else if (item.content && Array.isArray(item.content)) {
              extractFieldNames(
                item.content,
                item.flex_width || parentWidth,
                resultData
              );
            }
          });
        };

        extractFieldNames(firstResult.data.content);

        this.headers = headers;
      }
    }
  }
}
